import { IconButton, Menu, MenuItem, Tooltip } from "@mui/joy";
import { useLocalStorage } from "@uidotdev/usehooks";
import { useState } from "react";

/**
 *
 * @returns {ReactElement} WorkSessionSortOptions page
 */
export function WorkSessionSortOptions() {
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLSpanElement>();
  const [option, setOption] = useLocalStorage(
    "workSessionSortOption",
    "chronologically"
  );

  return (
    <>
      <Tooltip
        enterDelay={1000}
        enterNextDelay={1000}
        variant="outlined"
        arrow
        size="sm"
        title="Sort Options"
      >
        <IconButton
          color="neutral"
          onClick={(e) => {
            setMenuAnchorEl(e.currentTarget);
          }}
          size="sm"
          variant="plain"
        >
          <i className="fa-regular fa-bars-sort"></i>
        </IconButton>
      </Tooltip>
      <Menu
        size="sm"
        onClose={() => setMenuAnchorEl(null)}
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
      >
        <MenuItem
          selected={option === "chronologically"}
          onClick={() => {
            setOption("chronologically");
            setMenuAnchorEl(null);
          }}
          sx={{ gap: 2 }}
        >
          <i className="fa-regular fa-clock"></i>
          <span>Chronologically</span>
        </MenuItem>
        <MenuItem
          selected={option === "grouped"}
          onClick={() => {
            setOption("grouped");
            setMenuAnchorEl(null);
          }}
          sx={{ gap: 2 }}
        >
          <i className="fa-solid fa-layer-group"></i>
          <span>Grouped by type</span>
        </MenuItem>
      </Menu>
    </>
  );
}
